import { FileAccessedEvent } from '@rematter/frontend-lib-api-client/grpc/files/v1/file_events_pb';
import { Col, humanReadableDateTime } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';
import { getLocale } from '~/shared/utils/locale';

type FileAccessedDetailProps = {
  event: FileAccessedEvent;
};

export const FileAccessedDetail = ({ event }: FileAccessedDetailProps) => {
  const accessedAtStr = protoTimestampToZonedDateTimeString(event.accessedAt);

  return (
    <Col className="@FileAccessedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Access Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="File ID" value={event.fileId?.value} />
          <IDField
            label="Organization ID"
            value={event.organizationId?.value}
          />
          <IDField label="User ID" value={event.userId?.value} />
          <FieldDisplay label="Access Type" value={event.accessType} />
          <FieldDisplay label="IP Address" value={event.ipAddress} />
          <FieldDisplay label="User Agent" value={event.userAgent} />
          {accessedAtStr && (
            <FieldDisplay
              label="Accessed At"
              value={humanReadableDateTime(accessedAtStr, {
                locale: getLocale(),
              })}
            />
          )}
        </div>
      </Col>
    </Col>
  );
};
